import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { IAuthenticationService } from './i-authentication.service';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
  private authenticatedPrefixes = ['/api'];
  // Matched with `includes` (not `startsWith`): the direct-call-preferences endpoints carry a
  // variable userId/tenantId segment before the path suffix we care about, so a prefix match can't express them.
  // No leading slash on 'direct-call-preferences' so it also matches the self-service 'self-direct-call-preferences' route.
  private nonLogoutOnUnauthorizedPatterns = ['/api/ui-profiles/tenants/', 'direct-call-preferences'];

  public constructor(private readonly authenticationService: IAuthenticationService) {}

  public intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    if (this.authenticatedPrefixes.some((prefix) => req.url.startsWith(prefix))) {
      return this.handleAuthenticatedRequest(req, next);
    }

    return this.handleRequest(req, next);
  }

  private handleAuthenticatedRequest<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    return this.authenticationService.renewToken().pipe(switchMap(() => this.handleRequest(req, next)));
  }

  private handleRequest<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    return next.handle(req).pipe(
      catchError((err) => {
        if (err.status === 401 && this.shouldLogoutOnUnauthorized(req)) {
          this.authenticationService.onUnauthorized(req);
        }

        throw err;
      }),
    );
  }

  private shouldLogoutOnUnauthorized<T>(req: HttpRequest<T>): boolean {
    return !this.nonLogoutOnUnauthorizedPatterns.some((pattern) => req.url.includes(pattern));
  }
}
